export default __webpack_public_path__ + "static/media/learose5-480w.03656ba4.webp";